export default __webpack_public_path__ + "static/media/game2_active.89ee1055.png";